import { ReactNode } from 'react';
import styled from 'styled-components';
import { Dropdown } from '../Dropdown';
import { DropdownContentContainer } from '../DropdownContentContainer';
import { DropdownContentItem } from '../DropdownContentItem';

export const ComboInput = ({
  label,
  inputs,
}: {
  label: string;
  inputs: {
    name: string;
    children: ReactNode;
    isVisible: boolean;
    onAdd: () => void;
    onRemove: () => void;
  }[];
}) => {
  const isAnyInputVisible = (): boolean => inputs.some((input) => input.isVisible);
  const areAllInputsVisible = (): boolean => inputs.every((input) => input.isVisible);

  return (
    <Container>
      <Header>
        <span>{label}</span>
        {!areAllInputsVisible() && (
          <Dropdown
            trigger={
              <SideButtonContainer>
                <i className="icon-plus" />
              </SideButtonContainer>
            }
            horizontalAlign="right"
          >
            <DropdownContentContainer>
              {inputs.map(
                (input) =>
                  !input.isVisible && (
                    <DropdownContentItem key={`dropdown-item-${input.name}`} onClick={() => input.onAdd()}>
                      {input.name}
                    </DropdownContentItem>
                  )
              )}
            </DropdownContentContainer>
          </Dropdown>
        )}
      </Header>

      {isAnyInputVisible() && <Separator />}

      <Inputs>
        {inputs.map(
          (input) =>
            input.isVisible && (
              <Row key={`sub-input-${input.name}`}>
                {input.children}
                <SideButtonContainer onClick={() => input.onRemove()}>
                  <i className="icon-minus" />
                </SideButtonContainer>
              </Row>
            )
        )}
      </Inputs>
    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 5px;
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);
`;

const Header = styled.div`
  height: 25px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  > span {
    font-size: 11px;
    padding-left: 5px;
    color: var(--main-1);
  }
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  margin: 5px 0;

  background-color: var(--neutral-3);
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  gap: 5px;
  justify-content: space-between;
`;

const SideButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  i {
    width: 25px;
    height: 25px;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 12px;
    border-radius: var(--radius-2);

    transition:
      background-color 0.3s ease,
      color 0.3s ease;
    &:hover {
      background-color: var(--neutral-3);
      color: var(--main-1);
    }
  }
`;
